/**
 * Component to show a list of subscription orders.  
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Divider, FormControl, Grid, InputLabel, Link, MenuItem, Select,
         TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, TablePagination, Typography, Tooltip, Button} from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import { format } from 'date-fns';

import SOProjectListFetch from './SOProjectListFetch';

import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import { green, grey, amber } from '@mui/material/colors';
import SavingSpinner from '../ui/SavingSpinner';
import RefundAndTerminateDialog from './RefundAndTerminateDialog';

const abEnvironment = new AbEnvironment();

const SubscriptionOrdersQuery = graphql`
query SubscriptionOrdersQuery($accountId: UUID!, $projectId: UUID!, $first: Int, $offset: Int) {
  ordersWithoutProject : allOrderTs(condition: {customerId: $accountId}, first: $first, offset: $offset, orderBy: ACCEPTED_TIME_DESC) {
    totalCount
    nodes {
       orderId
       orderDescription
       orderStatus
       acceptedTime
       previousOrder
       replacingOrder
       projectId
       orderLineTsByOrderId {
        nodes {
          lineType
          billingFrequency
          
        }
      }
    }
  }
  ordersForProject : allOrderTs(condition: {customerId: $accountId, projectId: $projectId}, first: $first, offset: $offset, orderBy: ACCEPTED_TIME_DESC) {
    totalCount
    nodes {
       orderId
       orderDescription
       orderStatus
       acceptedTime
       previousOrder
       replacingOrder
       projectId
       orderLineTsByOrderId {
        nodes {
          lineType
          billingFrequency
          
        }
      }
    }
  }
  issubscriptionorderoutstanding(accountid: $accountId)
  issubscriptionorderoutstandingforproject(accountid: $accountId, projectid: $projectId )
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      // marginTop: -32,
    },
    flex: {
      flex: 1,
    },
    formControl: {
      marginBottom: '24',
    },
    nselect: {
      minWidth: 100
    },
    divider: {
      marginTop: 16,
      marginBottom: 16,
      marginLeft: 0,
    },
    button: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    dateField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 4,
      width: 180,
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 3,
      width: 160,
    },
      paper1: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paper2: {
      padding: 12,
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    paper3: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    topButton: {
      marginTop: 15
    },
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'left',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellB: {
      textAlign: 'right',
      verticalAlign: 'bottom',
    },
    tblHeadCellC: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    managedByLabel: {
      color: theme.palette.secondary.main,
      // fontWeight: 'bold',
    },
    /*
    link: {
      fontSize: 14
    }*/

});

const noProject = '00000000-0000-0000-0000-000000000000';

class SubscriptionOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      projectId:         noProject,
      projects:          null,
      mountComplete:     false,
      page:              0,
      rowsPerPage:       5,
      outstandingSO:     0,
      requestCancelDialog: false,
      requestCancelSpinner: false
    };  
  }

  componentDidMount() {
    SOProjectListFetch.fetch(this.props.accountId).toPromise()
    .then(pf => {
      let theCount = pf.getsubscriptionorderlistofprojects.totalCount;
      if (theCount === 0) {
        this.setState({mountComplete: true});
      } else {

        let thenodes = pf.getsubscriptionorderlistofprojects.nodes;
 
        this.setState({projectId: thenodes[0].projectId, projects: thenodes, mountComplete: true});

      }
    })
    .catch(err => {
      //nothing to do
    });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  setParentTab = (tv) => {
    if (this.props.setTabVal) {
      this.props.setTabVal(tv);
    }
  }

  /**
   * For reseller to go to an SO that is pending so that they can edit/adjust it
   */
  goToSO() {
    let propsToCache = {
      fromRequestApproval: false,
      accountId: this.props.accountId,
      companyName: this.props.account.accountName,
      contactLastName: this.props.account.contactLastName, 
      contactFirstName: this.props.account.contactFirstName, 
      contactEmail:  this.props.account.contactEmail};
    localStorage.setItem('soCustomerParms', JSON.stringify(propsToCache));
 
    this.props.history.push(`/subscriptionOrder`);
  }

  /**
   * For a customer to go to an SO that is pending so that they can accept it.
   */
  goToConfirmSO() {
    this.props.history.push('/steppercustomerauthorize');
  }
  
  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedCustomer, isAuthenticatedAppBind, isUnauthenticatedCustomer, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    }    
    if (!isAuthenticatedCustomer() && !isUnauthenticatedCustomer() && !isAuthenticatedReseller() && !isAuthenticatedAppBind()) {
      // others cannot see this component
      return ( <Redirect to='/home' /> );
    } 
    const statusOk = green[300];
    const statusReplaced = grey[500];
    const statusWaiting = amber[400];

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0) {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;


    // When called from CustomerAppList, props.pg will be set to "myApps"
    let thePage = this.props.pg;
    if (thePage == null)
      thePage = "custSubs";

    //limit the display of the "terminateAccount" segments depending on role and ID (must be customer and must be operating on own account)
    let showTerminateCustomer = (isAuthenticatedCustomer() || isUnauthenticatedCustomer()) && abEnvironment.getUserAttribute("a_id") === this.props.accountId;

    let managedByName = 'your purchasing agent';
    if (this.props.parentAccount != null && this.props.parentAccount.accountName != null) {
      managedByName = this.props.parentAccount.accountName;
    }
    
    if (!this.state.mountComplete) {
      return (<LoadingSpinner />);
    }

    return (
      <div className={classes.root}>
        <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
          {/* This is used on both reseller view of customer, and customer.  We need different title blocks. */}
          {showTerminateCustomer === false &&
          <Grid item>
            <Typography variant="h6">
              Subscription order history
            </Typography>
          </Grid>}

          {showTerminateCustomer === true &&
          <Grid item>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography variant="h6">Order history</Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
                  <Grid item>
                    <Typography variant="body2">History of your agreements and terms with&nbsp;</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2" className={classes.managedByLabel}>{managedByName}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2">.</Typography>
                  </Grid>
                </Grid>
              </Grid>                                
            </Grid>
          </Grid>}

          {/* Terminate customer button and dialog. */}
          {showTerminateCustomer && 
            (
              this.state.requestCancelSpinner ? 
              <Grid item>
                <Button color="primary" variant="outlined">
                  <SavingSpinner />
                </Button>
              </Grid>
            : this.props.account && this.props.account.accountType === 4 && !this.state.requestCancelSpinner &&
            <>
              <Grid item>
                <Tooltip title={'You can terminate your subscription arrangement and receive a balance refund at any time.'}>
                  <Button color="primary"
                    variant={'outlined'}
                    disabled={this.props.account.accountStatus === 3}
                    onClick={() => { this.setState({ requestCancelDialog: true }); }}
                    >
                    Terminate agreement
                  </Button>
                </Tooltip>
              </Grid>
              <RefundAndTerminateDialog account={this.props.account} auth={this.props.auth}
                    setSaveSpinner={(value) => { this.setState({ requestCancelSpinner: value }) }}
                open={this.state.requestCancelDialog}
                onClose={() => { this.setState({ requestCancelDialog: false }); }}
                onCancel={() => { this.setState({ requestCancelDialog: false }); }}
              />
            </>
            )
          }
        </Grid>
        <Divider className={classes.divider}/>

        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={SubscriptionOrdersQuery}
          variables={{
            accountId: this.props.accountId,
            projectId: this.state.projectId,
            first: first,
            offset: offset
          }}
          render={({ error, props }) => {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {

              let totalCount = 0;
              let theOrders = 0;

              if (this.state.projectId === noProject) {
                totalCount = props.ordersWithoutProject.totalCount;
                theOrders = props.ordersWithoutProject.nodes;
              } else {
                totalCount = props.ordersForProject.totalCount;
                theOrders = props.ordersForProject.nodes;
              }

              let ordersWithDescription = []
              //produce a summary of whats in each SO
              for (let i = 0; i < theOrders.length; i++) {
                let order = theOrders[i];

                let newOrder = { ...order };

                let lines = order.orderLineTsByOrderId.nodes;

                let subCount = 0;
                let oneTimeSvcCount = 0;
                let monthlySvcCount = 0;
                for (let y = 0; y < lines.length; y++) {
                  let line = lines[y];
                  if (line.lineType === 0) {
                    subCount = subCount + 1;

                  } else {
                    if (line.billingFrequency === 0) {
                      oneTimeSvcCount = oneTimeSvcCount + 1;
                    } else { 
                      monthlySvcCount = monthlySvcCount + 1;
                    }
                  }
                }

                let orderDescription = '';
                if (subCount === 0) {
                  orderDescription = orderDescription + subCount + ' subscriptions';
                } else if (subCount === 1) {
                  orderDescription = orderDescription + subCount + ' subscription';
                } else {
                  orderDescription = orderDescription + subCount + ' subscriptions';
                }

                if (oneTimeSvcCount > 0) {
                  if (oneTimeSvcCount === 1) {
                    orderDescription = orderDescription + ', ' + oneTimeSvcCount + ' one-time service';
                  } else { 
                    orderDescription = orderDescription + ', ' + oneTimeSvcCount + ' one-time services';
                  }
                }

                if (monthlySvcCount > 0) {
                  if (monthlySvcCount === 1) {
                    orderDescription = orderDescription + ', ' + monthlySvcCount + ' monthly service';
                  } else { 
                    orderDescription = orderDescription + ', ' + monthlySvcCount + ' monthly services';
                  }
                }
                newOrder.orderDescription = orderDescription;

                ordersWithDescription.push(newOrder);
              }
              
              let pendingOrderSentString = '';
              let pendingOrderSent = this.props.account.lastSoSent;
              if (pendingOrderSent) {
                let tempDate = new Date(pendingOrderSent + 'Z');
                pendingOrderSentString = ' (sent on ' + format(tempDate, 'PP @ pp') + ')';
              }
              return (
                <div className={classes.paper}>

                  <Grid container spacing={2} direction="row" justifyContent="flex-start">
                    {this.state.projectId === noProject && props.issubscriptionorderoutstanding === 1 && thePage === "myApps" &&
                    <Grid item xs={12}>
                      <Grid container spacing={2} direction="row" alignItems="center" justifyContent="space-between">
                        <Grid item>
                          <Typography>You have an outstanding subscription order.</Typography>
                        </Grid>
                        <Grid item>
                          <Button color="primary"
                            variant="contained"
                            onClick={() => { this.goToConfirmSO(); }}
                          >
                            View new order
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>}
                    {this.state.projectId !== noProject && props.issubscriptionorderoutstandingforproject === 1 && thePage === "myApps" &&
                    <Grid item xs={12}>
                      <Grid container spacing={2} direction="row" alignItems="center" justifyContent="space-between">
                        <Grid item>
                          <Typography>You have an outstanding subscription order for this project.</Typography>
                        </Grid>
                        <Grid item>
                          <Button color="primary"
                            variant="contained"
                            onClick={() => { this.goToConfirmSO(); }}
                          >
                            View new order
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>}

                    {this.state.projectId !== noProject &&
                    <React.Fragment>
                      <Grid item xs={3} className={classes.formControl}>
                        <FormControl  variant="standard" style={{marginTop: '4px'}}>
                          <InputLabel shrink htmlFor="outstandingSO">Project</InputLabel>
                          <Select
                            value={this.state.projectId}
                            inputProps={{
                              name: 'projectId',
                              id: 'projectId',
                            }}
                            onChange={(e) => { this.setState({ projectId: e.target.value, page: 0 }); } }
                            className={classes.nselect}
                          >
                            {this.state.projects.map(n => {
                              return(<MenuItem key={n.projectId} value={n.projectId}>{n.projectName}</MenuItem>); 
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={9}>
                      </Grid>
                    </React.Fragment>}

                    <Grid item xs={12}>
                      <TableContainer>
                        <Table>
                          <TableHead className={classes.tblHead}>
                            <TableRow className={classes.tblHeadRow}>
                              <TableCell className={classes.tblHeadCell}>Accepted date</TableCell>
                              <TableCell className={classes.tblHeadCell}>Description</TableCell>
                              {/*<TableCell className={classes.tblHeadCell}>Previous order</TableCell>
                              <TableCell className={classes.tblHeadCell}>Replacing order</TableCell>*/}
                              <TableCell className={classes.tblHeadCellC}>Status</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.projectId === noProject && props.issubscriptionorderoutstanding === 1 && thePage !== "myApps" &&
                            <TableRow key={'pending' + 1}>
                              <TableCell>
                                <Typography variant="body2">
                                  <Link component="button"
                                    variant="body2"
                                    onClick={() => this.goToSO()}>
                                    Pending approval
                                  </Link>
                                </Typography>
                              </TableCell>
                              <TableCell><Typography variant="body2">{'Pending subscription order' + pendingOrderSentString}</Typography></TableCell>
                              <TableCell align="center">
                                <HourglassEmpty htmlColor={statusWaiting} />
                              </TableCell>
                            </TableRow>}

                            {this.state.projectId !== noProject && props.issubscriptionorderoutstandingforproject === 1 && thePage !== "myApps" &&
                            <TableRow key={'pending' + 1}>
                              <TableCell>
                                <Typography variant="body2">
                                  <Link component="button"
                                    variant="body2"
                                    onClick={() => this.goToSO()}>
                                    Pending approval
                                  </Link>
                                </Typography>
                              </TableCell>
                              <TableCell><Typography variant="body2">{'Pending subscription order' + pendingOrderSentString}</Typography></TableCell>
                              <TableCell align="center">
                                <HourglassEmpty htmlColor={statusWaiting} />
                              </TableCell>
                            </TableRow>}

                            {ordersWithDescription.map(n => {
                              let acceptedTime = format(new Date(n.acceptedTime), 'yyyy-MM-dd');
                              let orderView = 'subscriptionorderview?orderId=' + n.orderId;
                              return (
                                <TableRow key={n.orderId}>
                                  <TableCell>
                                    <Typography variant="body2">
                                      <Link component="button"
                                        variant="body2"
                                        onClick={() => this.goTo(orderView)}>
                                        {acceptedTime}
                                      </Link>
                                    </Typography>
                                  </TableCell>
                                  <TableCell><Typography variant="body2">{n.orderDescription}</Typography></TableCell>
                                  {/*<TableCell><Typography variant="body2">{n.previousOrder}</Typography></TableCell>
                                  <TableCell><Typography variant="body2">{n.replacingOrder}</Typography></TableCell>*/}
                                  <TableCell align="center">
                                    {n.orderStatus === 2 &&
                                      <Tooltip title='This subscription order is active'>
                                        <CheckCircle htmlColor={statusOk} />
                                      </Tooltip>
                                    }
                                    {n.orderStatus === 3 &&
                                      <Tooltip title='This subscription order has been replaced'>
                                        <CheckCircleOutline htmlColor={statusReplaced} />
                                      </Tooltip>
                                    }
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                    <Grid item xs={12}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />
                    </Grid>
                  </Grid>
                </div>
              )
            }
            return (
              <LoadingSpinner />
            );
          }}
        />
      </div>
    );
  }
}

SubscriptionOrders.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(SubscriptionOrders);
